import { Hero } from "@/components/sections/Hero";
import { Intro } from "@/components/sections/Intro";
import { Stays } from "@/components/sections/Stays";
import { Amenities } from "@/components/sections/Amenities";
import { Reviews } from "@/components/sections/Reviews";
import { Experiences } from "@/components/sections/Experiences";
import { ContactCta } from "@/components/sections/ContactCta";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Intro />
      <Stays />
      <Amenities />
      <Reviews />
      <Experiences />
      <ContactCta />
    </main>
  );
}
